import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CaptchaComponent } from './captcha/captcha.component';

import { FormsModule } from '@angular/forms';


@NgModule({
  declarations: [
    CaptchaComponent
  ],
  exports: [
    CaptchaComponent
  ],
  imports: [
    CommonModule,
    FormsModule
  ]
})
export class CaptchaModule { }
